import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function StickyWrapperRender({ node, children }) {
  const content = node.content || {};
  
  const top = content.top || '0px';
  const zIndex = content.zIndex || '50';
  const bgColor = content.bgColor || 'transparent';
  
  // Im Live-Frontend sticky, im Editor relativ, damit der Editor-Canvas nicht völlig zerbricht 
  // (wäre sonst beim Scrollen über allen anderen Toolbars)
  // Wir machen es trotzdem sticky, aber mit weniger aggressivem Z-Index.
  
  return (
    <div style={{
      position: 'sticky',
      top: top,
      zIndex: zIndex,
      backgroundColor: bgColor,
      width: '100%',
      minHeight: '20px'
    }}>
      {(!children || children.length === 0) ? (
        <div style={{ padding: '10px', border: '1px dashed #00A9E0', color: '#00A9E0', fontSize: '12px' }}>
          Sticky Wrapper. Box bleibt beim Scrollen kleben.
        </div>
      ) : (
        children
      )}
    </div>
  );
}

registry.register('StickyWrapper', {
  label: 'Sticky Element',
  icon: '📌', 
  category: 'layout',
  component: StickyWrapperRender,
  
  defaultProps: {
    children: [], // Nimmt content auf
    content: {
      top: '0px',
      zIndex: '50',
      bgColor: 'transparent'
    },
    style: {
      desktop: {}
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Sticky Konfiguration',
          fields: [
            { name: 'content.top', label: 'Abstand nach oben (Top)', type: 'text' },
            { name: 'content.zIndex', label: 'Z-Index (z.B. 50)', type: 'text' },
            { name: 'content.bgColor', label: 'Hintergrundfarbe', type: 'color' }
          ]
        }
      ]
    }
  ]
});
